<mat-menu #actionContextMenu="matMenu">
  <button mat-menu-item
          [matMenuTriggerFor]="teamSelection">
    {{ (plural ? Localization.AssignJobs : Localization.AssignJob) | translate }}
  </button>
  <button mat-menu-item
          (click)="delete.emit()">
    {{ (plural ? Localization.DeleteJobs : Localization.DeleteJob) | translate }}
  </button>
</mat-menu>

<mat-menu #teamSelection="matMenu">
  <button mat-menu-item
          (click)="assign.emit(team)"
          *ngFor="let team of teams">{{team.label}}</button>
</mat-menu>

